import { useState, useEffect } from "react";
import { checkProjectContainsProducts } from "utils/treeUtils/isProjectContainsProducts";

export const useProjectHasProducts = (projectId?: string) => {
  const [hasProducts, setHasProducts] = useState<boolean | null>(null);

  useEffect(() => {
    if (!projectId) return;

    let cancelled = false;
    checkProjectContainsProducts(projectId).then((result) => {
      if (!cancelled) {
        setHasProducts(result);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [projectId]);

  return { hasProducts: projectId ? hasProducts : null };
};
